import Vue from 'vue'
import App from './views/App.vue'
import VueRouter from 'vue-router'
import router from './routes'
import store from "./store";
import jQuery from 'jquery'

global.jQuery = jQuery;
import Popper from 'popper.js'

global.Popper = Popper;
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios'
import ApiService from './common/api.service'
import VueI18n from 'vue-i18n'
import messages from "./lang"

import './assets/css/style.css'
import './assets/fonts/Roboto-Light.ttf';
import './assets/fonts/Roboto-Black.ttf';
import './assets/fonts/ropa-sans-v9-latin-ext_latin-italic.woff';
import './assets/fonts/ropa-sans-v9-latin-ext_latin-italic.woff2';
import './assets/fonts/ropa-sans-v9-latin-ext_latin-regular.woff';
import './assets/fonts/ropa-sans-v9-latin-ext_latin-regular.woff2';
import './assets/fonts/Montserrat-Italic-VariableFont_wght.ttf';
import './assets/fonts/Montserrat-VariableFont_wght.ttf';
import './assets/fonts/Mulish.ttf';
import './assets/fonts/Mulish-Italic.ttf';

Vue.use(VueRouter);
Vue.use(VueI18n);

ApiService.init();

const i18n = new VueI18n({
  locale: 'en',
  messages,
})

Vue.filter('currency', function (value) {
  if (!value) return ''
  value = value.toString()
  return Math.floor(value);
})


new Vue({
  el: '#app',
  router,
  store,
  axios,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js